<template>
    <div class="container">
        <b-container fluid v-show="!showPage">
              <b-row>
                <div class="text-center m-5">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>&nbsp;Loading...</strong>
                </div>
              </b-row>
        </b-container>   
        <b-container fluid v-show="showPage" style="margin-top:100px;">
            <b-row style="text-align: left;">
                <b-col>
                    <br>
                    <h3>Cluster : {{this.clusterId}}</h3>
                </b-col>
            </b-row>
            <b-row>
                <b-col align-self="center">
                    <hr>                    
                </b-col>
            </b-row> 
            <b-row style="text-align: left;">
                <b-col>
                    <ul>
                        <li><b>Cluster ID:</b> {{this.clusterId}}</li>
                        <li><b>Total Number of MGEs members:</b> <span style="color:red;font-weight: bold;">{{this.clustInfo.mge_partners}}</span></li>
                        <li><b>Total Number of Protein partners:</b> <span style="color:red;font-weight: bold;">{{this.clustInfo.prot_partners}}</span></li>
                        <li><b>Total Number of Samples:</b> <span style="color:red;font-weight: bold;">{{this.clustInfo.tot_sams}}</span></li>
                        <li><b>Study count:</b> <span style="color:red;font-weight: bold;">{{this.clustInfo.tot_study}}</span></li>                        
                    </ul>
                </b-col>
                
            </b-row>
            <b-row style="height:500px">                
                <b-col v-show="showMap" style="height:100%" md="12" lg="6" >
                    <div id="chartdiv" style="height:100%"></div>
                </b-col>                
                <b-col v-show="showDPie" style="height:100%" md="12" lg="6">
                    <Plotly :data="diseasePie" :layout="dPieLayout" :autoResize="true" style="height:100%"></Plotly>
                </b-col>
            </b-row>
            <b-row v-if="showPlot">
                    <b-col>
                    <h4>eMGE protein cluster</h4>
                    </b-col>
            </b-row>
            <b-row v-if="showPlot">                
                    <b-col>
                        <Plotly :data="barPlotDat" :layout="retLayout" :autoResize="true" style="width:100%;height:100%"></Plotly>
                    </b-col>
            </b-row>
            <br>
            <b-row style="text-align: left;">
                <b-col>
                    <h3>Associated eMGEs</h3>
                </b-col>
            </b-row>
            <b-row style="text-align: left;">
                <b-col>
                    <hr>
                    <p><download-csv
                            :data   = "clust_data" style="cursor: pointer;">
                        To download the eMGE data for this cluster <span style="color:red;font-weight: bold;"> {{clusterId}} </span> in CSV format: &nbsp;
                        <font-awesome-icon icon="download" ></font-awesome-icon>
                        </download-csv></p>
                </b-col>
            </b-row>
            <b-row style="margin-top:10px;margin-bottom:10px">                            
                        <b-col>
                        <b-input-group style="margin-top:10px;margin-bottom:10px">
                                        <!-- <label for="filterHmPairs" style="padding-top:5px">Search</label> -->
                                        <b-form-input
                                        v-model="filter"
                                        type="search"
                                        id="filterHmPairs"
                                        placeholder="Type to Search"
                                        ></b-form-input>
                                        <b-input-group-append>
                                            <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                        </b-input-group-append>
                                    </b-input-group>                
                        </b-col>
            </b-row>
            <b-row style="text-align: left;">
                <b-col>
                    <hr>
                    <b-table
                        responsive
                        show-empty
                        :busy.sync="clustIsBusy"
                        :striped="false"
                        :outlined="true"
                        :items="clust_data"
                        :fields="clust_fields"
                        :current-page="currentPage"
                        :per-page="perPage"
                        :filter ="filter"
                    >
                        <template  v-slot:table-busy>
                            <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>Loading...</strong>
                            </div>
                        </template>
                        <template v-slot:cell(MGEs_id) ="row">
                                <router-link :to="{ path: '/viewmge/'+row.item.MGEs_id.trim()}" target="_blank">{{row.item.MGEs_id.trim()}} <font-awesome-icon icon="external-link-square-alt" size='sm'></font-awesome-icon></router-link>
                        </template>
                        <template v-slot:cell(PC_id) ="row">
                                <router-link :to="{ path: '/viewprotcluster/'+row.item.PC_id}" target="_blank">{{row.item.PC_id}} <font-awesome-icon icon="external-link-square-alt" size='sm'></font-awesome-icon></router-link>
                        </template>
                        <template v-slot:cell(host_range) ="row">
                                <span v-if="row.item.host_range != null && row.item.host_range != 'NULL'">
                                    {{row.item.host_range}}
                                </span>
                                <span v-else>
                                    unknown
                                </span>
                        </template>
                        <!-- <template v-slot:cell(MGEs_cluster)>
                            {{this.clusterId}}
                        </template>                         -->
                    </b-table>
                    <b-row>
                            <b-col md="6" class="my-1">
                                <b-pagination
                                v-model="currentPage"
                                :total-rows="totalClustRows"
                                :per-page="perPage"
                                class="my-0"
                                ></b-pagination>
                            </b-col>
                            <b-col md="6" class="my-1">
                                <b-form-group label-cols-sm="3" label="Per page" class="mb-0">
                                <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import axios from 'axios'
const _ = require("underscore")
import * as am4core from "@amcharts/amcharts4/core";
import * as am4maps from "@amcharts/amcharts4/maps";
import am4geodata_worldLow from '@amcharts/amcharts4-geodata/worldLow'
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import CountryMap from './CtryMap'

export default {
    data () {
        return{
            server_add:"https://mai.fudan.edu.cn/",
            showPage:false,
            filter:null,
            clustIsBusy:true,
            clust_data:[],
            clust_fields:[
                { key:'MGEs_id',label:'eMGE ID',sortable:false}, //, 
                { key: 'PC_id', label: 'Protein family ID', sortable: false},
                { key:'function',label:'Protein function',sortable:false}, //, 
                { key: 'host_range', label: 'Host range', sortable: false},
            ],
            totalClustRows: 1,
            currentPage: 1,
            perPage: 15,
            pageOptions: [5, 10, 15,25],
            clusterId:'',
            clustInfo:{},
            barPlotDat:[],
            retLayout:{
                // title:'MGE Protein cluster',                
                autosize: true,
                annotations: [],
                xaxis: {
                    ticks: '',
                    side: 'top',
                    // title:"MGE Protein cluster"
                },
                yaxis: {
                    ticks: '',
                    ticksuffix: ' ',
                    // width: 700,
                    // height: 700,
                    // autosize: false
                }
            },
            showPlot:false,
            map:null,
            colorCache: {},
            showMap:false,
            showDPie:false,
            diseasePie:[],
            dPieLayout:{
                title:'Phenotype distribution',
                // height: 300,
                // width: 300
            },
        }
    },
    mounted() {
        this.init()
        this.initMap()
    },
    methods: {
        init(){
            this.clusterId = this.$route.params.clustid
            this.importClustList()
            this.genChartDat()
        },
        importClustList(){
            axios.post(this.server_add+'query/clustSubBig',
            {
                clustId:this.clusterId
            },{ timeout: 320000}).then(retDat => {
                // console.log(retDat.data)
                if(retDat.status == 200){
                    this.clust_data = retDat.data.sub
                    this.clustInfo.host_tot = retDat.data.host_tot
                    this.clustInfo.mge_partners = retDat.data.mge_partners
                    this.clustInfo.prot_partners = retDat.data.prot_partners
                    this.clustInfo.tot_sams = retDat.data.tot_sams
                    this.clustInfo.tot_study = retDat.data.tot_study
                    this.clustIsBusy = false
                    this.totalClustRows = this.clust_data.length
                    this.formHeatMapDat()
                    this.showPage = true
                }else{
                    this.clustIsBusy = false
                    console.log('no data for cluster ',this.clusterId)
                }
            }).catch(err => {
                console.log(err)
            })
        },
        formHeatMapDat(){
            var x = [], y=[], z=[],z_functions = []
            var simple_map = {}
            var x_map = {},y_map = {}
            for(var i=0;i<this.clust_data.length;i++){
                if(!x.includes(this.clust_data[i]['PC_id'])){
                    x.push(this.clust_data[i]['PC_id'])
                    z_functions.push(this.clust_data[i]['function'])
                    x_map[this.clust_data[i]['PC_id']] = x.length
                }
                if(!y.includes(this.clust_data[i]['MGEs_id'])){
                    y.push(this.clust_data[i]['MGEs_id'])
                    y_map[this.clust_data[i]['MGEs_id']] = y.length
                    z.push(0)
                }
                simple_map[this.clust_data[i]['MGEs_id']+this.clust_data[i]['PC_id']] = 1
            }
            var prev = '',row_Ar = []
            for(var st=0;st<z.length;st++){
                z[st] = new Array(Object.keys(x_map).length).fill(0)
            }
            // console.log(x,y,z,x_map,y_map,z_functions)
            for(var k=0;k<this.clust_data.length;k++){
                var y_ind = y_map[this.clust_data[k]['MGEs_id']]
                var x_ind = x_map[this.clust_data[k]['PC_id']]
                z[y_ind-1][x_ind-1] = 1
                // text.push(`Protein ID:${this.clust_data[k]['PC_id']}<br>eMGE ID:${this.clust_data[k]['MGEs_id']}<br>Function:${z_functions[x_ind]}`)
            }

            var text = z.map((row, i) => row.map((item, j) => {
            return `Protein ID: ${x[j]}<br>eMGE ID: ${y[i]}<br>Function: ${z_functions[j]}`
            }))
            // console.log(text)

            var colorscaleValue = [
                [0, '#ECF0F1'],
                [1, '#FDEBD0']
            ];
            this.barPlotDat = [{
                x: x,
                y: y,
                z: z,
                type: 'heatmap',
                colorscale: colorscaleValue,
                showscale: false,
                xgap :	3,
                ygap :	3,
                text: text,
                hoverinfo: 'text',
                // dat:z_functions,
                // hovertemplate:`Protein ID: %{x}<br>eMGE ID: %{y}<br>Interaction: %{z}<extra></extra>`,
                // text:text,
                // hoverinfo: 'text'
            }]
            this.showPlot = true
        },
        trial(z){
            return 'hi '+z
        },
        fillarray(array,totSz){
            if(array.length<totSz){
                array.push(0)
                this.fillarray(array,totSz)
            }
        },
        initMap(){
            this.map = am4core.create("chartdiv", am4maps.MapChart);
            this.map.geodata = am4geodata_worldLow;
            this.map.projection = new am4maps.projections.Miller();
            this.map.zoomControl = new am4maps.ZoomControl();
            
            let title = this.map.titles.create();
            title.text = "MGE Source Distribution";
            title.fontSize = 19;
            title.marginBottom = 30;

            var button = this.map.chartContainer.createChild(am4core.Button);
            button.padding(5, 5, 5, 5);
            button.align = "right";
            button.marginRight = 15;
            var that = this
            button.events.on("hit", function() {
                that.map.goHome();
            });
            button.icon = new am4core.Sprite();
            button.icon.path = "M16,8 L14,8 L14,16 L10,16 L10,10 L6,10 L6,16 L2,16 L2,8 L0,8 L8,0 L16,8 Z M16,8";
        },
        genChartDat(){
            axios.post(this.server_add+'query/clustStat',
            {
                clustId:this.clusterId
            },{ timeout: 320000}).then(retDat => {
                if(retDat.status == 200 && retDat.data.length >=1){
                    var grp = _.groupBy(retDat.data,'NCBI_Run_ID')
                    var lis = []
                    _.keys(grp).forEach(key => {
                        var sub = grp[key]
                        lis.push(sub[0])
                    });
                    this.loadPieChart(lis)
                    this.loadMapChartDat(lis)
                    this.showPage = true
                }
            }).catch(err => {
                console.log(err)
            })
        },
        loadPieChart(baseDat){
            var grp = _.groupBy(baseDat,'Disease')
            var keyMap = Object.keys(grp)
            var szMap = Object.values(grp).map(p=>p.length)
            var phenoAr = Object.values(grp).map(p=>p[0]['DiseaseName'])
            var total = szMap.reduce((a, b) => a + b)
            var text = szMap.map((v, i) => `${keyMap[i]}<br>${'Sample count:'+v}<br>${parseFloat(v / total * 100).toFixed(1)}%<br>${'Phenotype:'+phenoAr[i]}`)            
            this.diseasePie = [{
                type: "pie",
                values: szMap,
                labels: keyMap,
                textinfo: "label+percent",
                textposition: "outside",
                text:text,
                hoverinfo: 'text',
                automargin: true
            }]
            this.showDPie = true
        },
        loadMapChartDat(baseDat){
            // var singleSet = []
            // var tem_grp = _.groupBy(baseDat,'MGEs_id')
            // _.keys(tem_grp).forEach(element => {
            //     singleSet.push(tem_grp[element][0])
            // });
            var grp = _.groupBy(baseDat,'Country')
            var ctryMap = CountryMap.getCtryMap()
            var that = this
            var all_dat = []            
            Object.keys(grp).forEach(function(key) {
                var res = that.procCtryName(key,grp[key].length,ctryMap)
                if(res.length>=1){
                    all_dat.push.apply(all_dat,res)
                }
            });
            var polygonSeries = this.map.series.push(new am4maps.MapPolygonSeries());
            polygonSeries.data = all_dat            
            var polygonTemplate = polygonSeries.mapPolygons.template;
            polygonTemplate.tooltipText = "{name}(Sample count:{value})";
            polygonTemplate.propertyFields.fill = "fill";
            polygonSeries.useGeodata = true;
            this.showMap = true
            this.map.homeZoomLevel = 8;
            this.map.goHome()
        },
        procCtryName(countryName,size,ctryMap){
            var sub = countryName.replace(' AND ',',').replace(' and ',',').replace(' OR ',',').replace(' or ',',').split(',')
            var ctrAr = []
            for(var ind in sub){
                var su = sub[ind]                
                if(ctryMap.has(su)){
                    ctrAr.push({'name':su,'id':ctryMap.get(su),'value':size,'fill':this.randomColor(ctryMap.get(su))})
                }else{
                    if(su.includes('United States of America')){
                        ctrAr.push({'name':'United States','id':'US','value':size,'fill':this.randomColor('US')})
                    }
                }
            }
            return ctrAr
        },
        randomColor(id) {
            const r = () => Math.floor(256 * Math.random());
            return this.colorCache[id] || (this.colorCache[id] = `rgb(${r()}, ${r()}, ${r()})`);
        },
    }
}
</script>

<style lang="less">
    #boxBg{
    background-color: #ECE9E9;
    padding-top: 10px;
    padding-bottom: 5px;
    padding-left: 5px;
    align-content: left;
    color: black;
}
.medium_col{
  width: 120px !important;
  height: 25px !important;
  max-height: 25px !important;
  max-width: 120px !important;
  text-align: center;
}
</style>